<template>
  <div>

    <div>
      <div class="flex align-items marginBottom10 flex-wrap">
        <div class="flex align-items marginRight10 marginBottom10">
          <span class="marginRight10">车辆编号:</span>
          <div class="width200">
            <el-input
              v-model="searchData.code"
              placeholder="请输入"
              @keyup.enter.native="handleSearch"
              clearable
              maxlength="20"
            ></el-input>
          </div>
        </div>

        <div class="marginRight10 marginBottom10">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
            class="marginLeft10"
          >查询</el-button>
        </div>

        <div class="marginRight10 marginBottom10">
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="handleReset"
            class="marginLeft10"
          >重置</el-button>
        </div>

      </div>
    </div>

    <avue-crud
      ref="crud"
      class="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >

    </avue-crud>

    <div style="text-align:right;margin-top:20px">
      <el-button
        type="primary"
        @click="selectClassify"
      >确定</el-button>
    </div>

  </div>
</template>

<script>
import { getCarList } from "@/api/region/manage";
export default {
  name: "goods",
  props: {
    defaultData: {
      type: Array,
    },
    show: {
      type: Boolean,
      default: false,
    },
    carId: {
      type: String,
    },
  },
  data() {
    return {
      selectList: [],
      searchData: {
        name: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      option: {
        title: "",
        titleSize: "h3",
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        size: "mini",
        selection: true, // 显示多选框
        reserveSelection: true,
        rowKey: "id",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: "车型编号",
            prop: "code",
          },
        ],
      },
    };
  },
  watch: {
    show(value) {
      this.tableData = [];
      this.$refs.crud.toggleSelection();
      this.onLoad();
    },
  },
  methods: {
    toggleSelection(val) {
      if (val) {
        this.$refs.crud.toggleSelection(val);
      } else {
        this.$refs.crud.toggleSelection();
      }
    },
    onLoad() {
      this.showLoading = true;
      getCarList({
        id: this.carId,
        regionId: this.$route.query.id,
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
          if (this.show) {
            // this.$nextTick(() => {
            console.log("defaultData", this.defaultData);
            this.toggleSelection(this.defaultData);
            // });
          } else {
            this.toggleSelection();
          }
        }
      });
    },
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    handleReset() {
      this.searchData = {};
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectClassify() {
      this.$emit("change", this.selectList);
    },
    selectionChange(list) {
      this.selectList = list;
    },
  },
};
</script>

<style scoped>
/* .crud /deep/.el-card__body .el-form .el-table .el-table__fixed-right {
  height: 100% !important;
} */
</style>